import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import Transactions from "./Transactions";
import IncomeTax from "./IncomeTax";

const SHOW_INCOME_TAX = false;

const ReportsPage = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Box sx={{ width: "100%", px: { xs: 0.5, sm: 2, md: 3 }, py: { xs: 1, sm: 2 } }}>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        sx={{ marginBottom: { xs: 1.2, sm: 2.5 } }}
      >
        <Tab label="Extrato" />
        {SHOW_INCOME_TAX && <Tab label="Imposto de Renda" />}
      </Tabs>
      <Box>
        {activeTab === 0 && <Transactions />}
        {SHOW_INCOME_TAX && activeTab === 1 && <IncomeTax />}
      </Box>
    </Box>
  );
};

export default ReportsPage;
